(ns renolit-roofing-service.layout.components
  (:require [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [reagent.core :as r]))

(defn link-button
  [text href]
  [:div.link-button
   [:a {:href href}
    text]
   [layout.icon/icon
    {:key :right-arrow}]])

(defn search-input
  [{:keys [placeholder]}]
  [:input.search {:type "text" :placeholder placeholder}])

(defn back-link
  [text href]
  [:div.back-link
   [layout.icon/icon
    {:key :back}]
   [:a {:href href}
    text]])

(defn back-link-history
  [text]
  [:div.back-link
   [layout.icon/icon
    {:key :back}]
   [:a {:on-click #(.back js/window.history)}
    text]])

(defn entity-section
  [{:keys [title title-transl-kw button-component]} body]
  [:div.entity-section
   [:div.entity-section__header
    [:h2.entity-section__title
     (or title (t [title-transl-kw]))]
    (when button-component
      [button-component])]
   [:div.entity-section__body
    body]])

(defn collapsable-section
  [{:keys [start-open] :as _opts} _body]
  (let [open? (r/atom (if (boolean? start-open) start-open false))]
    (fn [{:keys [title class icon]} body]
      [:div.collapsable-section
       {:class (cond-> []
                 @open?
                 (conj "collapsable-section--expanded")

                 class
                 (conj class))}

       [:button.flat-btn.collapsable-section__header
        {:on-click #(swap! open? not)
         :type "button"}
        [:span.collapsable-section__header-title
         (when icon icon) title]
        [layout.icon/icon
         {:key (if @open? :indicator-show :indicator-hide)}]]
       (when @open?
         [:div.collapsable-section__body
          body])])))